import { render, staticRenderFns } from "./StatCircle.vue?vue&type=template&id=5816e090&scoped=true&"
import script from "./StatCircle.vue?vue&type=script&lang=js&"
export * from "./StatCircle.vue?vue&type=script&lang=js&"
import style0 from "./StatCircle.vue?vue&type=style&index=0&id=5816e090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5816e090",
  null
  
)

export default component.exports